import React from 'react';
import { graphql } from 'gatsby';
import { render } from '@/utils/story-composer';
import Layout from '@/components/layout';
import { unwrapResults } from '@/utils/graphql';
import { extractMetadata } from '@/utils/metadata';

export default function PageIndex({ location, data }) {
	const { layout, fallbackLayout, page, featuredBlogs } = unwrapResults(data);
	const { disable_header: disableHeader, disable_footer: disableFooter } = page?.content || {};

	return (
		<Layout
			location={location}
			layout={layout || fallbackLayout}
			metadata={extractMetadata(page)}
			localizations={page.localizations}
			disableHeader={disableHeader}
			disableFooter={disableFooter}
		>
			{render(page.content, { images: page.images, featuredBlogs, lang: page.lang })}
		</Layout>
	);
}

export const query = graphql`
	query PageQuery($uuid: String!, $locale: String!) {
		page: storyblokPage(uuid: { eq: $uuid }, lang: { eq: $locale }) {
			name
			content
			lang
			full_slug
			localizations {
				full_slug
				id
				locale
				name
			}

			images {
				id
				localFile {
					publicURL
					childImageSharp {
						gatsbyImageData(placeholder: NONE)
					}
				}
			}
		}
		layout: storyblokGlobal(lang: { eq: $locale }) {
			content
		}
		fallbackLayout: storyblokGlobal(lang: { eq: "en" }) {
			content
		}
		featuredBlogs: allStoryblokBlogPost(filter: { featured: { eq: true }, lang: { eq: $locale } }, limit: 3) {
			edges {
				node {
					id
					uuid
					full_slug
					name
					content
					lang
					published_at
					first_published_at
					translated_slugs {
						path
						name
						lang
					}
					images {
						id
						localFile {
							publicURL
							childImageSharp {
								gatsbyImageData(placeholder: NONE)
							}
						}
					}
				}
			}
		}
	}
`;
